import useWindowsSize from "@/Hooks/useWindowsSize";
import Skeleton from "react-loading-skeleton";

type Props = {
  totales: number;
};

export const DefaultPlpList = ({ totales }: Props): JSX.Element => {
  const rows = [];

  for (let i = 0; i < totales; i++) {
    rows.push(<DesingViewList key={i} />);
  }

  return <>{rows}</>;
};

export const DesingViewList = (): JSX.Element => {
  return (
    <div className="ps-product ps-product--wide">
      <div className="ps-product__thumbnail">
        <Skeleton width={170} height={170} />
      </div>
      <div className="ps-product__container">
        <div className="ps-product__content">
          <span className="ps-product__title">
            <Skeleton />
          </span>
          <p className="ps-product__vendor">
            <Skeleton />
          </p>
        </div>
        <div className="ps-product__shopping">
          <p className="#">
            <Skeleton />
          </p>
        </div>
      </div>
    </div>
  );
};
